export const LIGHT = 'light'
export const DARK = 'dark'
export const POSITIVE = 'positive'
export const NEGATIVE = 'negative'
export const INFO = 'info'
export const WARNING = 'warning'
export const DARK_NO_ICON = 'dark_no_icon'
export const DARK_INFO = 'dark_info'
export const BASIC_INFO = 'basic_info'
